import { IoMdAdd } from 'react-icons/io';
import { SlArrowDown } from 'react-icons/sl';
import { useState } from 'react';

import UserStoryContent from './UserStoryContent';
import TaskContent from './TaskContent';
import BugContent from './BugContent';

const SprintContent = ({ sectionId, sectionData, setAlldata, alldata }) => {
  const [showStories, setShowStories] = useState(true);
  return (
    <div className="relative rounded-lg">
      <div className="sticky top-0 z-50 flex w-full items-center justify-between rounded-t-md border border-zinc-700 bg-zinc-800 px-4 py-1.5">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-bold text-gray-50">{sectionData.name}</h3>
          <p>{`(${sectionData.noOfissues} issues)`}</p>
        </div>

        <div className="flex items-center gap-4">
          <button className="inline-flex items-center justify-center gap-1 text-nowrap rounded-2xl border bg-[#1d1d1f] px-2 py-0.5 text-base font-semibold text-gray-50 transition duration-100 hover:text-white">
            <span>
              <IoMdAdd />
            </span>
            Create issue
          </button>
          <button className="inline-flex items-center justify-center gap-1 text-nowrap rounded-2xl border bg-[#1d1d1f] px-2 py-0.5 text-base font-semibold text-gray-50 transition duration-100 hover:text-white">
            Complete sprint
          </button>
          <button
            className={`${
              !showStories ? 'rotate-180' : 'rotate-0'
            } transition duration-150`}
            onClick={() => setShowStories((prev) => !prev)}
          >
            <SlArrowDown size={12} />
          </button>
        </div>
      </div>
      {/* {sectionData?.objective && (
        <p className="text-base px-4 font-semibold my-2">
          {sectionData.objective}
        </p>
      )} */}
      {showStories && (
        <div className="flex flex-col overflow-y-auto">
          {sectionData.issues.length > 0 ? (
            sectionData.issues.map((item, index) => {
              return item.fields?.issuetype?.name === 'Story' ? (
                <UserStoryContent
                  key={item.id}
                  storyId={item.id}
                  data={sectionData}
                  sectionId={sectionId}
                />
              ) : item.fields?.issuetype?.name === 'Task' ? (
                <TaskContent key={item.id} item={item} />
              ) : (
                <BugContent key={item.id} item={item} />
              );
            })
          ) : (
            <div className="border border-zinc-700 bg-zinc-950 p-2">
              <div className="flex items-center justify-start rounded-lg border border-dashed p-4">
                <p className="w-full text-center text-base font-semibold">
                  Plan a new Sprint with new issues
                </p>
              </div>
            </div>
          )}
        </div>
      )}
      {showStories && (
        <div className="mt-4 flex w-full items-center justify-center  px-2">
          <button className=" flex h-10 w-full items-center justify-center  gap-3 rounded-lg bg-zinc-700 px-8 text-center text-lg font-semibold hover:bg-[#343438]">
            <span className="font-bold">
              <IoMdAdd />
            </span>
            <span>Create issue</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SprintContent;
